export const gitInfo = {
  "commit": "741c49b934",
  "commitLong": "741c49b9344e0a5411d4f32fe51e3f15a6eff038",
  "branch": "HEAD",
  "lastCommitTime": "2026-11-04T07:42:26Z"
}